import React from 'react';
import PropTypes from 'prop-types';
import { isAfter } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { Table } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

const Versions = ({ form, setVersion }) => {
  const styles = {
    pill: {
      height: 30,
      padding: '0 20px',
      display: 'inline-block',
      lineHeight: '30px',
      textAlign: 'center',
      borderRadius: 15,
      backgroundColor: '#444',
      color: '#fff',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: 1,
      fontSize: 12,
      float: 'right'
    }
  };

  return (
    <div style={styles.component}>
      <Table
        columns={[
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'publish_date',
            label: 'Publish Date',
            render: version => {
              return formatInTimeZone(version.publish_date, 'UTC', 'MMM do, yyyy');
            }
          },
          {
            id: 'status',
            label: 'Status',
            render: version => {
              const is_scheduled = isAfter(new Date(version.publish_date), Date.now());

              if (is_scheduled) {
                return (
                  <div style={Object.assign({}, styles.pill, { background: Colors.BLUE.hex })}>
                    Scheduled
                  </div>
                );
              } else if (version.id === form.version_id) {
                return (
                  <div style={Object.assign({}, styles.pill, { background: Colors.GREEN.hex })}>
                    Live
                  </div>
                );
              } else {
                return null;
              }
            }
          }
        ]}
        data={form.form_versions}
        onRowClick={setVersion}
      />
    </div>
  );
};

Versions.propTypes = {
  form: PropTypes.object,
  setVersion: PropTypes.func
};

export default Versions;
